/**
 * Встраиваемый режим: сайт открыт панелью внутри чужой страницы (юзерскрипт
 * для fundoor.pro кладёт /auto/new?embed=1&src=<ссылка графика> в iframe).
 *
 * В панели шириной ~440px шапка с меню, футер и мобильная навигация съедают
 * половину высоты, поэтому AppShell рисует их только вне панели.
 *
 * Флаг запоминается в sessionStorage: внутри панели адрес меняется (вход →
 * /login → обратно, создание сессии → /auto), и `embed=1` из ссылки по
 * дороге теряется. sessionStorage живёт ровно в этом iframe, обычные вкладки
 * сайта его не видят.
 */
import { isTelegramWebApp } from './telegram';

const KEY = 'sb_embed';

const inFrame = (): boolean => {
  try { return window.self !== window.top; } catch { return true; }
};

export function isEmbed(): boolean {
  if (typeof window === 'undefined') return false;
  // Telegram Mini App — тот же компактный вид: экран телефона, своя шапка у Telegram.
  if (isTelegramWebApp()) return true;
  if (new URLSearchParams(window.location.search).get('embed') === '1') {
    try { sessionStorage.setItem(KEY, '1'); } catch { /* приватный режим */ }
    return true;
  }
  // Флаг из прошлого адреса этой же панели. Без iframe не верим ему: открытая
  // по «на сайте» вкладка должна быть обычным сайтом.
  try { return inFrame() && sessionStorage.getItem(KEY) === '1'; } catch { return false; }
}

/** Ссылка на ту же страницу сайта в обычной вкладке — без `embed`. */
export function fullSiteHref(): string {
  const u = new URL(window.location.href);
  u.searchParams.delete('embed');
  return u.toString();
}
